/**
 * @generated SignedSource<<3b132e61ddf1ec75c803443be78ee3f2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoutineEditAssignedRolesListItem_Routine$data = {
  readonly isOrg: boolean;
  readonly ownerTeam: {
    readonly id: string;
  } | null;
  readonly " $fragmentType": "RoutineEditAssignedRolesListItem_Routine";
};
export type RoutineEditAssignedRolesListItem_Routine$key = {
  readonly " $data"?: RoutineEditAssignedRolesListItem_Routine$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoutineEditAssignedRolesListItem_Routine">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoutineEditAssignedRolesListItem_Routine",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isOrg",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "ownerTeam",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Routine",
  "abstractKey": null
};

(node as any).hash = "33754fc82c41c68355e63773440909d8";

export default node;
